import { UseMutationOptions } from '@tanstack/react-query';

import { AppointmentValueResponse, ClickAppointmentValue } from 'domains/value/types';
import useMutation from 'hooks/useMutation';
import { CuredApiPaths } from 'models/enums';

import MutationKeys from './keys';

const useClickAppointmentValue = (
    mutateOptions?: UseMutationOptions<AppointmentValueResponse, Error, ClickAppointmentValue>
) =>
    useMutation<ClickAppointmentValue, AppointmentValueResponse>(
        MutationKeys.GET_APPOINTMENT_VALUE,
        CuredApiPaths.APP_CLICK_APPOINTMENT_VALUE,
        mutateOptions
    );

export default useClickAppointmentValue;
